/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MessagingConsentStatus } from "./MessagingConsentStatus";
import {
  MessagingConsentStatusFromJSON,
  MessagingConsentStatusFromJSONTyped,
  MessagingConsentStatusToJSON,
  MessagingConsentStatusToJSONTyped,
} from "./MessagingConsentStatus";
import type { MessagingProvider } from "./MessagingProvider";
import {
  MessagingProviderFromJSON,
  MessagingProviderFromJSONTyped,
  MessagingProviderToJSON,
  MessagingProviderToJSONTyped,
} from "./MessagingProvider";

/**
 *
 * @export
 * @interface MessagingChannel
 */
export interface MessagingChannel {
  /**
   *
   * @type {string}
   * @memberof MessagingChannel
   */
  id: string;
  /**
   *
   * @type {MessagingProvider}
   * @memberof MessagingChannel
   */
  provider: MessagingProvider;
  /**
   *
   * @type {string}
   * @memberof MessagingChannel
   */
  externalAddress: string;
  /**
   *
   * @type {string}
   * @memberof MessagingChannel
   */
  destination: string;
  /**
   *
   * @type {Date}
   * @memberof MessagingChannel
   */
  linkedAt: Date;
  /**
   *
   * @type {MessagingConsentStatus}
   * @memberof MessagingChannel
   */
  consentStatus: MessagingConsentStatus;
}

/**
 * Check if a given object implements the MessagingChannel interface.
 */
export function instanceOfMessagingChannel(
  value: object
): value is MessagingChannel {
  if (!("id" in value) || value["id"] === undefined) return false;
  if (!("provider" in value) || value["provider"] === undefined) return false;
  if (!("externalAddress" in value) || value["externalAddress"] === undefined)
    return false;
  if (!("destination" in value) || value["destination"] === undefined)
    return false;
  if (!("linkedAt" in value) || value["linkedAt"] === undefined) return false;
  if (!("consentStatus" in value) || value["consentStatus"] === undefined)
    return false;
  return true;
}

export function MessagingChannelFromJSON(json: any): MessagingChannel {
  return MessagingChannelFromJSONTyped(json, false);
}

export function MessagingChannelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MessagingChannel {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"],
    provider: MessagingProviderFromJSON(json["provider"]),
    externalAddress: json["external_address"],
    destination: json["destination"],
    linkedAt: new Date(json["linked_at"]),
    consentStatus: MessagingConsentStatusFromJSON(json["consent_status"]),
  };
}

export function MessagingChannelToJSON(json: any): MessagingChannel {
  return MessagingChannelToJSONTyped(json, false);
}

export function MessagingChannelToJSONTyped(
  value?: MessagingChannel | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    provider: MessagingProviderToJSON(value["provider"]),
    external_address: value["externalAddress"],
    destination: value["destination"],
    linked_at: value["linkedAt"].toISOString(),
    consent_status: MessagingConsentStatusToJSON(value["consentStatus"]),
  };
}
